/* eslint-disable */

import BookmarkedPosts from "components/features/bookmarked-posts/BookmarkedPosts";

const BookmarkedPostsPage = () => {
  return <BookmarkedPosts />;
};

export default BookmarkedPostsPage;
